module.exports = __webpack_public_path__ + "fonts/Lato-MediumItalic.b56b2012.eot";